import { useEffect, useState } from "react";
import { useDebounce } from "@hooks/useDebounce";

/**
 * Debounce input value state
 *
 * @param input initial input value
 * @param handler event handler to be debounced.
 * @param delayMs Debounce delay in milliseconds.
 */
export function useDebouncedInput<TArgs>(
    input: TArgs,
    handler: (input: TArgs) => void,
    delayMs: number,
): [TArgs, (input: TArgs) => void] {
    const [inputVal, setInputVal] = useState(input);

    const debouncedUpdate = useDebounce(handler, delayMs);

    const setInputValAndDebounce = (updatedVal: TArgs) => {
        setInputVal(updatedVal);
        debouncedUpdate(updatedVal);
    };

    useEffect(() => {
        setInputVal(input);
    }, [input]);

    return [inputVal, setInputValAndDebounce];
}
